module.exports = __webpack_public_path__ + "static/media/legend_rainfall3day.3c7f1fde.png";